/* src/app/components/pages/order-invoice/order-invoice.component.scss */
.invoiceDialog .dialog-title {
  color: white;
  font-size: 21px;
}
.invoiceDialog .header {
  background-color: var(--theme-deafult-secondary);
}
.invoiceDialog .header-tab-action {
  background: rgba(0, 0, 0, 0.1490196078) !important;
  margin: 0px 5px;
  border-radius: 10px;
  color: #ffffff;
}
.invoiceDialog .mat-mdc-dialog-content {
  margin: 0px;
  padding: 23px 25px;
}
.invoiceDialog .mat-mdc-dialog-content .horizontalLine {
  border-top: 1px solid #5e5e5e;
  box-shadow: 0px 1px 2px #5e5e5e;
  margin: 30px 0px;
}
.invoiceDialog .mat-mdc-dialog-content .table1 {
  max-width: 100%;
}
.invoiceDialog .mat-mdc-dialog-content .table1 table {
  display: grid;
  border-collapse: collapse;
  background-color: transparent;
  border-spacing: 0px;
  min-width: 100%;
  grid-template-columns: minmax(50px, 1fr) minmax(50px, 1.67fr) minmax(50px, 1.67fr) minmax(50px, 1.67fr) minmax(50px, 3.33fr) minmax(50px, 1.67fr);
}
.invoiceDialog .mat-mdc-dialog-content .table1 thead,
.invoiceDialog .mat-mdc-dialog-content .table1 tbody,
.invoiceDialog .mat-mdc-dialog-content .table1 tr {
  display: contents;
}
.invoiceDialog .mat-mdc-dialog-content .table1 th,
.invoiceDialog .mat-mdc-dialog-content .table1 td {
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoiceDialog .mat-mdc-dialog-content .table1 th {
  position: sticky;
  top: 0;
  background: #eeeeee;
  font-weight: bold;
  font-size: 14px;
  color: black;
  text-align: center;
  border: 1px solid #999;
  background-color: #eee;
  padding: 5px;
  border-bottom: 0px;
}
.invoiceDialog .mat-mdc-dialog-content .table1 td {
  color: black;
  text-align: center;
  border: 1px solid #999;
  padding: 5px;
}
.invoiceDialog .mat-mdc-dialog-content .table1 tr:nth-child(even) td {
  background: #f8f6ff;
}
.invoiceDialog .mat-mdc-dialog-content .table2 {
  max-width: 100%;
}
.invoiceDialog .mat-mdc-dialog-content .table2 table {
  display: grid;
  border-collapse: collapse;
  background-color: transparent;
  border-spacing: 0px;
  min-width: 100%;
  grid-template-columns: minmax(50px, 1fr) minmax(50px, 1.67fr) minmax(50px, 1.67fr) minmax(50px, 1.67fr) minmax(50px, 3.33fr) minmax(50px, 1.67fr) minmax(50px, 3.33fr);
}
.invoiceDialog .mat-mdc-dialog-content .table2 thead,
.invoiceDialog .mat-mdc-dialog-content .table2 tbody,
.invoiceDialog .mat-mdc-dialog-content .table2 tr {
  display: contents;
}
.invoiceDialog .mat-mdc-dialog-content .table2 th,
.invoiceDialog .mat-mdc-dialog-content .table2 td {
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invoiceDialog .mat-mdc-dialog-content .table2 th {
  position: sticky;
  top: 0;
  font-weight: bold;
  font-size: 14px;
  color: black;
  text-align: center;
  border: 1px solid #999;
  background-color: #eee;
  padding: 5px;
  border-bottom: 0px;
}
.invoiceDialog .mat-mdc-dialog-content .table2 td {
  color: black;
  text-align: center;
  border: 1px solid #999;
  padding: 5px;
}
.invoiceDialog .mat-mdc-dialog-content .table2 tr:nth-child(even) td {
  background: #f8f6ff;
}
.invoiceDialog .mat-mdc-dialog-content .noteBox {
  height: 100px;
  border: 1px solid #e0e0e0;
}
.invoiceDialog .mat-mdc-dialog-content .borderBox {
  border: 1px solid #5e5e5e;
}
.invoiceDialog .mat-mdc-dialog-content .footer {
  background-color: #eeeeee;
  padding: 15px;
  margin-top: 5px;
}
.invoiceDialog .mat-mdc-dialog-content .footer p {
  color: black;
  font-size: 14px;
}
.invoiceDialog .mat-mdc-dialog-content .table3td {
  text-align: right;
  border: 1px solid #999;
  width: 130px;
  border-bottom: 0px;
}
.invoiceDialog .mat-mdc-dialog-content .table3tdLast {
  text-align: right;
  border: 1px solid #999;
  width: 130px;
}
.invoiceDialog .mat-mdc-dialog-content .table3 td {
  padding: 4px;
  color: #5e5e5e;
  font-size: 14px;
}
.invoiceDialog .mat-mdc-dialog-content .invoice h3 {
  color: #e0e0e0;
  font-size: 27px;
}
.invoiceDialog .p-t-10 {
  padding-top: 10px !important;
}
.invoiceDialog .p-r-15 {
  padding-right: 15px !important;
}
.invoiceDialog .m-b-30 {
  margin-bottom: 30px !important;
}
.invoiceDialog .print-icon {
  height: 15px;
  margin: 25px;
}
.invoiceDialog .print-icon .mat-mdc-icon-button {
  background-color: #007ec6;
  color: #fff;
}
.invoiceDialog .print-icon mat-icon {
  font-size: 25px;
  cursor: pointer;
}
.invoiceDialog .colorf-s-14 {
  color: #5e5e5e;
  font-size: 14px;
}
@media only screen and (max-width: 600px) {
  .invoiceDialog .p-r-b {
    padding: 0px 15px 20px 0px;
  }
}
::ng-deep .invoiceDialog .mat-mdc-dialog-container {
  margin: 0px;
  padding: 0px !important;
}
.close-button {
  float: right;
  top: -24px;
  right: -24px;
}
.close-icon {
  transition: 1s ease-in-out;
}
.close-icon:hover {
  transform: rotate(180deg);
}
::ng-deep .invoiceDialog .close-button {
  float: right;
  top: -52px;
  right: -52px;
}
::ng-deep .invoiceDialog .mat-mdc-dialog-container {
  overflow: unset;
}
/*# sourceMappingURL=order-invoice.component.css.map */
